import React from "react";
import StepIndicator from "./step-indicator/StepIndicator";
import {FormSectionElements} from "../../entities/formTemplateDataType";
import {ErrorAlertComponent} from "../odsCalloutBox/ErrorAlertComponent";
import FeedbackComponent from "./FeedbackComponent";
import {getRootComponent} from "../../utilities/ElementUtils";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getEnvVar } from "../../config/RuntimeConfig";

interface Props {
    //programContainer: ProgramContainer;
    field: FormSectionElements;
    isEng: boolean;
    code?: string;
    // Visible: boolean;
    callback,
}

export class TechErrorComponent extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

    }

    render() {
        // if (!this.props.Visible) return null;
        let field = this.props.field;
        FormValidationUtils.runJavascript(this.props?.field)

        const profile = getRootComponent(this.props.field).Profile;
        let backToLabel;
        let backToUrl;
        const body = this.props.isEng ? this.props.field.ErrorContentValue?? "The service is currently unavailable."
            : this.props.field.ErrorContentValueFRA ?? "Le service est actuellement indisponible."
        if (!profile) {
            backToLabel = this.props.isEng ? "Back to Ontario.ca" : "Revenir à Ontario.ca";
            backToUrl = this.props.isEng ? field.BackUrl ?? "https://www.ontario.ca/page/serviceontario" : field.BackUrlFRA ?? "https://www.ontario.ca/fr/page/serviceontario";
        } else {
            backToLabel = this.props.isEng ? "Back to home" : "Retour à l'accueil";
            backToUrl = this.props.isEng ? field.BackUrl ?? getEnvVar('CXP_URL') : field.BackUrlFRA ?? getEnvVar('CXP_URL_F');
        }
         
        let feedbackUrl;

        if (profile) {
            feedbackUrl = this.props.isEng ? getEnvVar('FEEDBACK_URL_CXP_USER') : getEnvVar('FEEDBACK_URL_CXP_USER_F');
         } else {
            feedbackUrl = this.props.isEng ? getEnvVar('FEEDBACK_URL_NO_CXP_USER') : getEnvVar('FEEDBACK_URL_NO_CXP_USER_F');
        }

        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser();
        const reactElement = htmlToReactParser.parse(this.props.isEng ? this.props.field.Value : this.props.field.ValueFRA);
        const programContainer =getRootComponent(this.props.field);
        const techErrorSection = programContainer?.ListOfFormSections?.find(s => s.IsTechErrorPage);

        return (
            <div>
                <div>
                    <StepIndicator withbackbtn={true} sectionSequence={techErrorSection?.Sequence ?? 0} section={techErrorSection} title={backToLabel} programContainer={programContainer}
                        isEng={this.props.isEng} isTechicalErrorPage={true} backToUrl={backToUrl}
                        callback={(currentStep) => { this.setState({ stepperIndex: currentStep }) }}>
                    </StepIndicator>
                </div>

                <div>
                    <ErrorAlertComponent 
                        title={this.props.isEng ? "There is a problem"
                            : "Il y a un problème"}
                        bodyMsg={body}
                        isEng={this.props.isEng} Visible={true} />
                </div>

                <div>
                    {reactElement}
                </div>        
                <p></p>
                <div>
                    <div>
                        <FeedbackComponent programContainer={programContainer} isEng={this.props.isEng} field={this.props.field} status="400" code={this.props.field.feedback?.code || this.props.code}></FeedbackComponent>
                    </div>
                </div>

            </div>
        )

    }
}